// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuOptions_container__37yoZ","lower":"MenuOptions_lower__2je7G","title":"MenuOptions_title__1Qtwb"};